var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"style":{},"d":"M92.7,20.1L61.6,50l31.1,29.9c3,2.9,3,7.7,0,10.6l-1.4,1.3   c-3,2.9-8,2.9-11,0L50,62.7L19.7,91.9c-3,2.9-8,2.9-11,0l-1.4-1.3c-3-2.9-3-7.7,0-10.6L38.4,50L7.3,20.1c-3-2.9-3-7.7,0-10.6   l1.4-1.3c3-2.9,8-2.9,11,0L50,37.3L80.3,8.1c3-2.9,8-2.9,11,0l1.4,1.3C95.8,12.4,95.8,17.1,92.7,20.1z","fillRule":"evenodd","clipRule":"evenodd"})));
}

Close.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 100 125","style":{"enableBackground":"new 0 0 100 100"},"xmlSpace":"preserve"};

module.exports = Close;

Close.default = Close;
